module.exports = __webpack_public_path__ + "img/portrait-098.c4fdb0e1.jpg";